import { createAction } from "@reduxjs/toolkit";

/**
 * Global "reset everything on logout" action, dispatched from GenericUtility
 * and listened for in every slice's extraReducers.
 *
 * Lives in its own file with ZERO imports back into the store or any slice
 * -- on purpose. It used to live in UiDb.ts (the store file), which every
 * slice (and GenericUtility) imported it from. Since UiDb.ts also imports
 * every slice (to build the store), that made a real ES module cycle:
 * UiDb.ts -> some slice -> ... -> GenericUtility -> UiDb.ts (still
 * mid-evaluation). Whichever binding UiDb.ts hadn't reached yet at that
 * point (this action, or `store` itself) was in the TDZ, and depending on
 * which module the JS engine happened to resolve first -- an ordering that
 * shifts with any unrelated change to the import graph, e.g. converting a
 * route to React.lazy() -- a totally unrelated file could throw
 * "Cannot access 'X' before initialization".
 *
 * Import this action from HERE, not from "./UiDb", in any slice or utility
 * that needs it. See nineui-circular-import-tdz.md for the full trace.
 */
export const resetAllState = createAction("RESET_ALL_STATE");
